export const ApplyDistributeArr = [
  {
    path: "distribute/:id(\\d+)",
    name: "distribute",
    meta: {
      title: "分销"
    },
    redirect: "/apply/distribute/:id(\\d+)/general",
    component: () => import("@/views/sidebar/itemFrame2.vue"),
    children: [
      {
        path: "general",
        name: "general",
        meta: {
          title: "分销概况"
        },
        component: () => import("@/views/apply/distribute/general.vue")
      },
      {
        path: "product",
        name: "product",
        meta: {
          title: "分销商品"
        },
        component: () => import("@/views/apply/distribute/product.vue")
      },
      {
        path: "distributorSet",
        name: "distributorSet",
        meta: {
          title: "分销商管理"
        },
        component: {
          render: c => c("router-view")
        },
        children: [
          {
            path: "people",
            name: "people",
            meta: {
              title: "分销商"
            },
            component: () =>
              import("@/views/apply/distribute/distributorSet/people.vue")
          },
          {
            path: "list",
            name: "list",
            meta: {
              title: "分销商列表"
            },
            component: () =>
              import("@/views/apply/distribute/distributorSet/list.vue")
          }
        ]
      },
      {
        path: "order",
        name: "order",
        meta: {
          title: "分销订单"
        },
        component: () => import("@/views/apply/distribute/order.vue")
      },
      {
        path: "withdrawSet",
        name: "withdrawSet",
        meta: {
          title: "提现管理"
        },
        // component: () =>
        //   import("@/views/apply/distribute/withdrawSet/audit.vue"),
        component: {
          render: c => c("router-view")
        },
        children: [
          {
            path: "audit",
            name: "audit",
            meta: {
              title: "待审核"
            },
            component: () =>
              import("@/views/apply/distribute/withdrawSet/audit.vue")
          },
          {
            path: "remit",
            name: "remit",
            meta: {
              title: "待打款"
            },
            component: () =>
              import("@/views/apply/distribute/withdrawSet/remit.vue")
          },
          {
            path: "finish",
            name: "finish",
            meta: {
              title: "已打款"
            },
            component: () =>
              import("@/views/apply/distribute/withdrawSet/finish.vue")
          },
          {
            path: "invalid",
            name: "invalid",
            meta: {
              title: "无效"
            },
            component: () =>
              import("@/views/apply/distribute/withdrawSet/invalid.vue")
          }
        ]
      },
      {
        path: "grade",
        name: "grade",
        meta: {
          title: "分销商等级"
        },
        component: () => import("@/views/apply/distribute/grade.vue")
      },
      {
        path: "edit_grade",
        name: "edit_grade",
        meta: {
          title: "修改分销等级"
        },
        component: () => import("@/views/apply/distribute/edit_grade.vue")
      },
      {
        path: "adgrade",
        name: "adgrade",
        meta: {
          title: "添加分销商等级"
        },
        component: () => import("@/views/apply/distribute/adgrade.vue")
      },
      {
        path: "set",
        name: "set",
        meta: {
          title: "分销设置"
        },
        component: {
          render: c => c("router-view")
        },
        children: [
          {
            path: "base",
            name: "base",
            meta: {
              title: "基础设置"
            },
            component: () => import("@/views/apply/distribute/set/base.vue")
          },
          {
            path: "settlemen",
            name: "settlemen",
            meta: {
              title: "结算设置"
            },
            component: () =>
              import("@/views/apply/distribute/set/settlemen.vue")
          },
          {
            path: "rank",
            name: "rank",
            meta: {
              title: "排行设置"
            },
            component: () =>
              import("@/views/apply/distribute/withdrawSet/rank.vue")
          },
          {
            path: "share",
            name: "share",
            meta: {
              title: "排行设置"
            },
            component: () =>
              import("@/views/apply/distribute/set/share.vue")
          },
        ]
      }
    ]
  }
];
